import { Component } from '@angular/core';
import { PlaceholderPageComponent } from '../../../pages/placeholder/placeholder-page.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [PlaceholderPageComponent],
  template: `
    <app-placeholder-page 
      title="pages.dashboard" 
      icon="home">
    </app-placeholder-page>
  `
})
export class DashboardComponent {}